import React from "react";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="App relative">
      <Outlet />
    </div>
  );
}

export default Layout;
